import { v4 as uuid } from "uuid"

import getUpdatedMatrix from "reducers/lockingSystemReducer/utils/getUpdatedMatrix"
import getLockingSystemPricePortions, {
	getLockingSystemMsrpPricePortions,
} from "reducers/lockingSystemReducer/utils/getLockingSystemPricePortions"
import getNameOfDuplicatedComponent from "reducers/lockingSystemReducer/utils/getNameOfDuplicatedComponent"

import {
	DispatchLockingSystemReducer,
	LockingSystemReducerState,
} from "reducers/lockingSystemReducer"
import { LockingSystemComponent } from "@secureo/common/typings/LockingSystem"

type DuplicateKeyComponentPayload = Pick<
	LockingSystemReducerState,
	| "keyComponentsUuids"
	| "componentsByUuid"
	| "matrix"
	| "matrixType"

	// Price
	| "singleNetPriceCents"
	| "singleGrossPriceCents"
	| "totalNetPriceCents"
	| "totalGrossPriceCents"

	// Msrp price
	| "singleNetMsrpPriceCents"
	| "singleGrossMsrpPriceCents"
	| "totalNetMsrpPriceCents"
	| "totalGrossMsrpPriceCents"
>

export const duplicateKeyComponent = (
	dispatch: DispatchLockingSystemReducer,
	reducerState: LockingSystemReducerState,
	uuidToDuplicate: string,
) => {
	const { lockingComponentsUuids, keyComponentsUuids, quantity, matrix } = reducerState

	const componentToDuplicate = reducerState.componentsByUuid[uuidToDuplicate]

	const keyComponent: LockingSystemComponent = {
		...componentToDuplicate,
		name: getNameOfDuplicatedComponent(componentToDuplicate.name),
		uuid: uuid(),
	}

	// Insert component after duplicated component
	const index = reducerState.keyComponentsUuids.indexOf(uuidToDuplicate)
	keyComponentsUuids.splice(index + 1, 0, keyComponent.uuid)

	// Duplicate column values
	for (let rowIndex = 0; rowIndex < matrix.length; rowIndex++) {
		matrix[rowIndex].splice(index + 1, 0, matrix[rowIndex][index])
	}

	const { matrix: updatedMatrix, matrixType } = getUpdatedMatrix(
		lockingComponentsUuids,
		keyComponentsUuids,
		matrix,
	)

	const componentsByUuid = {
		...reducerState.componentsByUuid,
		[keyComponent.uuid]: keyComponent,
	}

	const { singleNetPriceCents, singleGrossPriceCents, totalNetPriceCents, totalGrossPriceCents } =
		getLockingSystemPricePortions(componentsByUuid, quantity)

	const {
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	} = getLockingSystemMsrpPricePortions(componentsByUuid, quantity)

	const payload: DuplicateKeyComponentPayload = {
		keyComponentsUuids,
		componentsByUuid,
		matrix: updatedMatrix,
		matrixType,

		// Price
		singleNetPriceCents,
		singleGrossPriceCents,
		totalNetPriceCents,
		totalGrossPriceCents,

		// Msrp price
		singleNetMsrpPriceCents,
		singleGrossMsrpPriceCents,
		totalNetMsrpPriceCents,
		totalGrossMsrpPriceCents,
	}

	dispatch({
		type: "ADD_KEY_COMPONENT",
		payload,
	})
}
